module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-27-23-829.26ddd308.mp4";